<template>
  <notice-dialog
    :is-visible="isVisible"
    :title="$t('appointment.calendar_dialog_title')"
    :content="$t('appointment.calendar_dialog_subtitle')"
    :confirm-button-text="$t('common.close')"
    @close="$emit('close')"
    @confirm="$emit('close')"
  >
    <template v-slot:content>
      <div class="calendar-options">
        <div
          class="calendar-option"
          @click="selectCalendar('google')"
        >
          <div class="calendar-icon google">
            <span class="calendar-icon-symbol">G</span>
          </div>
          <div class="calendar-name">{{ $t('appointment.google_calendar') }}</div>
        </div>

        <div
          class="calendar-option"
          @click="selectCalendar('outlook')"
        >
          <div class="calendar-icon outlook">
            <span class="calendar-icon-symbol">O</span>
          </div>
          <div class="calendar-name">{{ $t('appointment.outlook_calendar') }}</div>
        </div>

        <div
          class="calendar-option"
          @click="selectCalendar('ical')"
        >
          <div class="calendar-icon ical">
            <span class="calendar-icon-symbol">iCS</span>
          </div>
          <div class="calendar-name">{{ $t('appointment.download_ics') }}</div>
        </div>
      </div>
    </template>
  </notice-dialog>
</template>

<script>
import NoticeDialog from './NoticeDialog.vue';

export default {
  name: 'CalendarPickerDialog',

  components: {
    NoticeDialog
  },

  props: {
    isVisible: {
      type: Boolean,
      default: false
    }
  },

  methods: {
    selectCalendar(type) {
      this.$emit('select-calendar', type);
      this.$emit('close');
    }
  }
};
</script>

<style scoped>
.calendar-options {
  display: flex;
  flex-direction: column;
  gap: 16px;
  margin: 20px 0;
}

.calendar-option {
  display: flex;
  align-items: center;
  padding: 12px;
  border-radius: 4px;
  border: 1px solid #e5e5e5;
  cursor: pointer;
  transition: all 0.2s;
}

.calendar-option:hover {
  background-color: #f5f5f5;
  border-color: #ccc;
  transform: translateY(-2px);
  box-shadow: 0 2px 5px rgba(0, 0, 0, 0.05);
}

.calendar-icon {
  width: 40px;
  height: 40px;
  border-radius: 50%;
  display: flex;
  align-items: center;
  justify-content: center;
  margin-right: 16px;
  color: white;
  font-weight: bold;
}

.calendar-icon.google {
  background-color: #4285F4;
}

.calendar-icon.outlook {
  background-color: #0078D4;
}

.calendar-icon.ical {
  background-color: #FF7700;
}

.calendar-name {
  font-size: 16px;
}

@media (max-width: 576px) {
  .calendar-options {
    gap: 12px;
  }

  .calendar-option {
    padding: 10px;
  }

  .calendar-icon {
    width: 32px;
    height: 32px;
    margin-right: 12px;
  }

  .calendar-name {
    font-size: 14px;
  }
}
</style>